import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";
import { useTranslation } from "react-i18next";

function Timeline() {
  const { t } = useTranslation();

  return (
    <div id="history">
      <div className="items-container">
        <h1>{t("history")}</h1>

        <VerticalTimeline>
          {/* ===== ISMR QUERY TOOL ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date={`2024 - ${t("present")}`}
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2024_2025_ismr_title")}</h3>
            <h4 className="vertical-timeline-element-subtitle">Universidade Estadual Paulista - UNESP</h4>
            <h5>Presidente Prudente, São Paulo, Brazil · Remota</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2024_2025_ismr_desc") }} />
          </VerticalTimelineElement>

          {/* ===== UNIVESP – FACILITADOR DE CURSO ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date={`2024 - ${t("present")}`}
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2024_univesp_title")}</h3>
            <h4 className="vertical-timeline-element-subtitle">Universidade Virtual do Estado de São Paulo - UNIVESP</h4>
            <h5>São Paulo, São Paulo, Brazil · Remota</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2024_univesp_desc") }} />
          </VerticalTimelineElement>

          {/* ===== MESTRADO ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date={`2024 - ${t("present")}`}
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2024")}</h3>
            <h5>São José do Rio Preto, São Paulo, Brazil</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2024_master_desc") }} />
          </VerticalTimelineElement>

          {/* ===== PÓS FAVENI – ENGENHARIA DE SOFTWARE ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date="2024 - 2025"
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2024_faveni_software")}</h3>
            <h5>Faculdade Venda Nova do Imigrante – FAVENI</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2024_faveni_software_desc") }} />
          </VerticalTimelineElement>

          {/* ===== PÓS FAVENI – SEGURANÇA DA INFORMAÇÃO ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date="2024 - 2025"
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2024_faveni_security")}</h3>
            <h5>Faculdade Venda Nova do Imigrante – FAVENI</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2024_faveni_security_desc") }} />
          </VerticalTimelineElement>

          {/* ===== RV DE LIMA ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date="2023 - 2023"
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2023_title")}</h3>
            <h4 className="vertical-timeline-element-subtitle">RV de Lima Comércio de Livros</h4>
            <h5>São Paulo, São Paulo, Brazil · Remota</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2023_desc") }} />
          </VerticalTimelineElement>


          {/* ===== SUPORTE TI ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date="2020 - 2021"
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2020")}</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Secretaria de Educação de Presidente Prudente (SEDUC)
            </h4>
            <h5>Presidente Prudente, São Paulo, Brazil · Presencial</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2020_desc") }} />
          </VerticalTimelineElement>

          {/* ===== GRADUAÇÃO ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date="2019 - 2024"
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2019")}</h3>
            <h5>Presidente Prudente, São Paulo, Brazil</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2019_desc") }} />
          </VerticalTimelineElement>

          {/* ===== INSTITUTO CONFÚCIO – MANDARIM ===== */}
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            contentStyle={{ background: "#fff", color: "var(--text-color)" }}
            contentArrowStyle={{ borderRight: "7px solid #fff" }}
            date="2018 - 2021"
            iconStyle={{ background: "#009bff", color: "#fff" }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">{t("timeline.2018_mandarin_title")}</h3>
            <h4 className="vertical-timeline-element-subtitle">Instituto Confúcio na UNESP</h4>
            <h5>São Paulo, São Paulo, Brazil · Professores nativos</h5>
            <div dangerouslySetInnerHTML={{ __html: t<string>("timeline.2018_mandarin_desc") }} />
          </VerticalTimelineElement>

        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
